import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=674f4929&scoped=true&"
import script from "./Bridge.vue?vue&type=script&lang=ts&"
export * from "./Bridge.vue?vue&type=script&lang=ts&"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=674f4929&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f4929",
  null
  
)

export default component.exports